import React from 'react';
import CustomAddChipSearch from '../../../../../../../components/CustomAddChipSearch';
import { userListToLabelEmailPhoneValue } from '../../../../../../../Apis/functions';
import { PersonChipBlack } from '../../../../../../../components/buttons/IconButtons';
import {SERVICE_ADVANCED_SEARCH} from "../../../../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../../../../Apis/Tables";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Step 1 of the Add User Deduction Policy stepper.
 * Allows selecting a single employee via chip search.
 */
const StepSelectUser = ({ user, setUser, emptyFields, cleanChipSearch, setCleanChipSearch, disabled }) => {

    return (
        <div className="row mt-3">
            <div className="col-12">
                <CustomAddChipSearch
                    autocompleteId="slt_ssu_user"
                    buttonId="btn_ssu_add_user"
                    label="name"
                    selectedList={user}
                    setSelectedList={setUser}
                    required
                    emptyFields={emptyFields && user.length === 0}
                    maxLength={1}
                    keyId="userId"
                    hideButton={false}
                    reset={false}
                    cleanChipSearch={cleanChipSearch}
                    setCleanChipSearch={setCleanChipSearch}
                    showSubSection={true}
                    sanitizeDataList={userListToLabelEmailPhoneValue}
                    Icon={PersonChipBlack}
                    disabled={disabled}
                    api={SERVICE_ADVANCED_SEARCH}
                    model={TABLES.PAYROLL_DEDUCTION_POLICY_USER_NOT_ASSIGNED}
                />
            </div>
        </div>
    );
};

export default StepSelectUser;
